<template>
  <div v-if="topic" :key="topic.type + '-' + topic.id">
    <div v-if="debug">{{ topic }}</div>
    <div
      class="mail__mail-item sm:pl-4 px-1 pt-6"
      :class="{'mail__opened-mail': !topic.unread}"
    >
      <div class="vx-row flex w-full">
        <div class="vx-col flex-shrink w-36">
          <vs-avatar
            class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
            :src="'http://files.xtrathai.com/' + topic.senderUUID" size="64px" />

        </div>

        <div class="vx-col flex flex-grow px-0">

          <div class="mail__details w-full">
            
            <div class="mb-1 flex flex-inline">
              <h5 v-if="topic.topic">
                {{ topic.topic }}</h5>
              <span v-else>
                {{ $t('no-subject') }}
              </span>
            </div>

            <div class="flex flex-inline justify-start items-center w-full">
              <div>
                <span class="font-bold">{{ topic.sender_name }}</span>
                <span class="font-semibold"
                  :class="{ '_auto_parentheses' : topic.sender_name.replace(/\s/g, '') }" >{{ $t('general.code') }} {{ topic.sender_code }}</span>
              </div>
              <span class="ml-4"> วิชา ภาค ปี (ชี้เพื่อดู Info)</span>
            </div>


            <div class="mail__message truncate" >
              <span v-if="showContent === true">{{ topic.content | filter_tags }}</span>
            </div>
          
          </div>
        </div>

        <div class="vx-col flex pr-0">
          <div class="mail-item__meta flex items-start">
            <div class="flex flex-col justify-center">
              <div class="flex justify-center">
                <span class="text-left">{{ topic.sendDate | date(true) }}</span>
                <span class="ml-1 text-right">{{ topic.sendDate | time }}</span>
              </div>

              <div class="flex flex-col justify-end">
                <vs-chip v-if="topic.unread" transparent color="warning" class="mt-1 my-auto" style="min-height: 20px;">
                  <span>UNREAD</span>
                </vs-chip>

                <vs-chip v-if="!topic.fromUser" transparent color="danger" class="mt-1 my-auto" style="min-height: 20px;">
                  <span>READ ONLY</span>
                </vs-chip>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <!-- MESSAGE ROW 2 : ACTIONS -->
      <div class="vx-row flex w-full pl-3 pb-4">

        <div class="vx-col w-24">
        </div>

        <div class="vx-col flex flex-grow pl-0">
          <div class="email__labels hidden sm:flex items-center">

            <div class="mb-1 flex flex-inline justify-between">
              <vs-chip v-if="topic.subject" transparent color="success" class="ml-2 my-auto" style="min-height: 20px;">
                <span>
                  {{ topic.subjectCode }} {{ topic.subjectName }}
                </span>
              </vs-chip>
            </div>

            <div class="h-2 w-2 rounded-full mr-2" 
              :class="'bg-' + labelColor(label)"
              v-for="(label, index) in topic.labels" :key="index">
              <vs-chip v-if="label" transparent color="warning" class="ml-2 my-auto" style="min-height: 20px;">
                <span>{{ label }}</span>
              </vs-chip>
            </div>
          </div>
          <!-- <vs-checkbox 
            v-model="isSelectedMessage"
            @click.stop class="vs-checkbox-small ml-0 mr-1" /> -->
          <!-- <feather-icon icon="StarIcon"
            class="cursor-pointer"
            :svgClasses="[{'text-warning fill-current stroke-current': message.isStarred}, 'w-5', 'h-5']"
            @click.stop="toggleIsStarred" /> -->
        </div>
      </div>
      <!-- / MESSAGE ROW 2 -->
    </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      require: true,
      default: null
    },
    showContent: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: "default"
    }
  },
  data() {
    return {
      debug: false
    }
  },
  computed: {
    topic() {
      return this.data;
    }
  }
}
</script>

<style>

</style>